import watchSetRole from './setRole';
import watchUpdateRole from './updateRole';

const watchEditRole = [watchSetRole, watchUpdateRole];

export default watchEditRole;
